import { render, staticRenderFns } from "./StorefinderMapMarker.vue?vue&type=template&id=570d462f"
import script from "./StorefinderMapMarker.vue?vue&type=script&lang=js"
export * from "./StorefinderMapMarker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('570d462f')) {
      api.createRecord('570d462f', component.options)
    } else {
      api.reload('570d462f', component.options)
    }
    module.hot.accept("./StorefinderMapMarker.vue?vue&type=template&id=570d462f", function () {
      api.rerender('570d462f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/storefinder/Resources/Private/Assets/Scripts/Components/Maps/StorefinderMapMarker.vue"
export default component.exports